import config from '../../config'

const getConfig = (key) => {
    return !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? config['development'][key] : config['production'][key]
}

export default getConfig